<p-table
  [value]="data()"
  [columns]="cols()"
  [showGridlines]="true"
  [scrollable]="true"
  scrollHeight="flex"
  stripedRows
  class="p-datatable-sm p-4">
  <ng-template #header let-columns>
    <tr>
      @for (col of columns; track col) {
        <th>
          {{ col.header }}
        </th>
      }
    </tr>
  </ng-template>
  <ng-template #body let-rowData let-columns="columns">
    <tr>
      @for (col of columns; track col) {
        <td>
          {{ rowData[col.field] }}
        </td>
      }
    </tr>
  </ng-template>
</p-table>
